import { Component, OnInit } from '@angular/core';
import { AppHotelService } from 'src/app/provider/app-hotel.service';
import { AppHotelModel } from 'src/app/views/models/app-hotel.model';
declare var grapesjs: any;

@Component({
  selector: 'kt-edit-mail-template',
  templateUrl: './edit-mail-template.component.html',
  styleUrls: ['./edit-mail-template.component.scss']
})
export class EditMailTemplateComponent implements OnInit {

  data: AppHotelModel = new AppHotelModel()
  segmentations = JSON.parse(localStorage.getItem("segmentations")) || []
  editor = null

  constructor(private appHotel: AppHotelService) { }

  ngOnInit() {

    this.appHotel.getHotelInfo(Number(localStorage.getItem("hotelId"))).subscribe((resp) => {
      this.data = resp
    })

    this.editor = grapesjs.init({
      container: '#gjs',
      plugins: ['gjs-preset-newsletter'],
      pluginsOpts: {
        'gjs-preset-newsletter': {
          modalTitleImport: 'Import template',
          // ... other options
        }
      }
    });
  }

  save(){
    console.log(this.editor.getHtml());
    
  }

}
